<template>
  <div class="welcome-page">
    <header class="welcome-header">
      <h1>Welcome to <span class="highlight">Our Tuition Institute</span></h1>
      <p>Your gateway to academic excellence.</p>
      <div class="button-group">
        <a href="#about" class="btn btn-primary">Learn More</a>
        <router-link to="login"><a href="#login" class="btn btn-secondary">Login</a></router-link>
      </div>
    </header>

    <section class="features">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <div class="feature-box">
              <i class="bi bi-book"></i>
              <h3>Expert Tutors</h3>
              <p>Learn from the best in the field with years of experience.</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="feature-box">
              <i class="bi bi-calendar"></i>
              <h3>Flexible Schedules</h3>
              <p>Choose the time that suits you best with our flexible scheduling.</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="feature-box">
              <i class="bi bi-people"></i>
              <h3>Interactive Classes</h3>
              <p>Engage in interactive classes that make learning fun and effective.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <footer class="welcome-footer">
      <p>&copy; 2024 Our Tuition Institute. All rights reserved.</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'WelcomePage',
}
</script>

<style lang="scss" scoped>
.welcome-page {
  text-align: center;
  color: #333;

  .welcome-header {
    background: #f8f9fa;
    padding: 50px 0;

    h1 {
      font-size: 2.5rem;
      margin-bottom: 1rem;
      .highlight {
        color: #007bff;
      }
    }

    p {
      font-size: 1.25rem;
      margin-bottom: 1.5rem;
    }

    .button-group {
      display: flex;
      justify-content: center;
      gap: 10px;

      .btn-primary {
        padding: 0.75rem 1.5rem;
        font-size: 1rem;
      }

      .btn-secondary {
        padding: 0.75rem 1.5rem;
        font-size: 1rem;
        background-color: #6c757d;
        border-color: #6c757d;
      }
    }
  }

  .features {
    padding: 50px 0;

    .feature-box {
      background: #fff;
      border-radius: 10px;
      padding: 20px;
      text-align: center;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      margin-bottom: 30px;

      i {
        font-size: 3rem;
        color: #007bff;
        margin-bottom: 15px;
      }

      h3 {
        font-size: 1.5rem;
        margin-bottom: 10px;
      }

      p {
        font-size: 1rem;
      }
    }
  }

  .welcome-footer {
    background: #f1f1f1;
    padding: 20px;
    position: fixed;
    bottom: 0;
    width: 100%;

    p {
      margin: 0;
      font-size: 0.875rem;
    }
  }
}
</style>
